import { AppContext } from '@lightspeed-invoicing/core-client/frontend';
import React, { Component } from 'react';
import { FormattedDate, FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import Icon from "../common/icon/icon.component.jsx";
import LabelBadge from '../common/label/badge.component.jsx';
import SideBar from '../common/layout/sidebar.component.jsx';
import SalesToolsTabs from '../common/layout/tabs/salestools.component.jsx';
import StandardList from '../common/listing/list.component.jsx';
import LoadingSpinner from '../common/spinner/loading.component.jsx';

class LabelListing extends Component {

    constructor(props, context) {
        super(props, context)

        this.state = {
            rows: [],
            headers: [],
            searchKeywords: '',
            loading: false,
        }
        this.handleSearchChange = this.handleSearchChange.bind(this)
    }

    componentDidMount() {
        SideBar.activateMenu('sales-tools')
        this.refreshSearch()
    }

    handleSearchChange(event) {
        const target = event.target;
        //TODO: replace url
        // history.replace({
        //     search: '?q=' + target.value,
        // })
        this.setState({
            searchKeywords: target.value
        }, () => {
            this.refreshSearch()
        })
    }

    refreshSearch() {
        this.setState({
            loading: true,
        })
        AppContext.getApiClient().get('/labels').then(r => {
            this.setState({
                headers: r.data.length > 0 ? this.headers() : [],
                rows: r.data.map(q => this.row(q)),
                loading: false,
            })
        })

    }

    headers() {
        return [
            <FormattedMessage
                id="listing.labels.list.headers.title_label"
                defaultMessage="Title"
            />,
            <FormattedMessage
                id="listing.labels.list.headers.type_label"
                defaultMessage="Type"
            />,
            <FormattedMessage
                id="listing.labels.list.headers.created_at_label"
                defaultMessage="Created at"
            />,
        ]
    }

    getLabelType(type) {
        switch (type) {
            case 'tag':
                return <span className={LabelBadge.getBadgeClassName(type)}>
                    <FormattedMessage
                        id="listing.labels.type.tag_label"
                        defaultMessage="Label"
                    />
                </span>
            case 'customer-tag':
                return <span className={LabelBadge.getBadgeClassName(type)}>
                    <FormattedMessage
                        id="listing.labels.type.tag_customer_label"
                        defaultMessage="Customer Label"
                    />
                </span>
            case 'manufacturer':
                return <span className={LabelBadge.getBadgeClassName(type)}>
                    <FormattedMessage
                        id="listing.labels.type.manufacturer_label"
                        defaultMessage="Manufacturer"
                    />
                </span>
            case 'customer-type':
                return <span className={LabelBadge.getBadgeClassName(type)}>
                    <FormattedMessage
                        id="listing.labels.type.customer_type_label"
                        defaultMessage="Customer type"
                    />
                </span>
            case 'vendor':
                return <span className={LabelBadge.getBadgeClassName(type)}>
                    <FormattedMessage
                        id="listing.labels.type.vendor_label"
                        defaultMessage="Vendor"
                    />
                </span>
            case 'brand':
                return <span className={LabelBadge.getBadgeClassName(type)}>
                    <FormattedMessage
                        id="listing.labels.type.brand_label"
                        defaultMessage="Brand"
                    />
                </span>
}
    }

    row(item) {
        return [
            <Link to={"/labels/edit/" + item.id}>{item.attributes.title}</Link>,
            this.getLabelType(item.attributes.type),
            <FormattedDate
                year='numeric'
                month='long'
                day='numeric'
                value={new Date(item.attributes.createdAt)} />,
        ]
    }

    render() {
        let list = <StandardList
            className="row pt-3"
            headers={this.state.headers}
            rows={this.state.rows}
        />
        if (this.state.loading) {
            list = <LoadingSpinner />
        }
        return (
            <div>
                <SalesToolsTabs />
                <div className="row ui-has-modules py-1">
                    <div className="col-12 ui-module mb-0">
                        <div className="row mb-0 justify-content-end">
                            <div className="col-12 col-md-4 col-lg-3 text-align-right text-truncate">

                                <Link to="/labels/new" className="btn btn-primary btn-sm w-100">
                                    <Icon value={"plus-circle"} />
                                    <FormattedMessage
                                        id="label.listing.add_label_btn"
                                        defaultMessage="Add label"
                                    />
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
                {list}
            </div>
        );
    }
}

export default LabelListing


// WEBPACK FOOTER //
// ./src/label/listing.component.jsx